/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=7fc61679&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=ts&"
export * from "./uploader.vue?vue&type=script&lang=ts&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=7fc61679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc61679",
  null
  
)

export default component.exports